import React, { useEffect, useState } from "react";
import Axios from './../../utils/api/axiosConf';
import { url } from './../../utils/api/api';
import { Row, Col, Modal } from "antd";
import { color } from "../../utils/themes/color";
import TABALE from "./../../components/table/table";
import INPUT from "./../../components/input/input";
import BUTTON from './../../components/buttons/button';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { RedNotif, GreenNotif, FarsiDate } from "../../utils/utils";
import SELECT from "./../../components/select/select";


export default function Wallet() {

    const [loading, setLoading] = useState({ 1: false, 2: false });
    const [data, setData] = useState([]);
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 });
    const [updater, setUpdater] = useState(1);
    const [item, setItem] = useState();
    const [editStatus, setEditStatus] = useState(false);
    const statuses = [{ "name": "درحال بررسی", "value": "pending" }, { "name": "رد شده ", "value": "rejected" }, { "name": " انجام شده ", "value": "completed" }, { "name": "لغو شده ", "value": "cancelled" }];
    const [withdrawStatus, setWithdrawStatus] = useState({});



    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}withdraw/withdraw-list?limit=${page.pageSize}&pageNumber=${page.current}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    setLoading({ ...loading, 1: false })
                    setData(response.data.docs)
                    setPage({
                        ...page,
                        current: response.data.page,
                        total: response.data.totalDocs

                    })
                }
                else {
                    RedNotif(response.message)
                    
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [page.current, updater])


    const columns = [
        {
            title: 'نام کاربر',
            dataIndex: 'user',
            render: (user) => user != undefined ?
                <p> {user.fullName} </p>
                : <p></p>,
            key: '_id',
        },
        {
            title: 'شماره شبا',
            dataIndex: 'sheba',

        },
        {
            title: 'مقدار',
            dataIndex: 'amount',

        },
        {
            title: 'تاریخ',
            dataIndex: 'insertDate',
            render: (insertDate) => <p>{FarsiDate(insertDate)}</p>,

        },

        {
            title: 'وضعیت',
            dataIndex: 'status',
            render: (status) => <p>{Status(status)}</p>,
            key: '_id',

        },
        {
            title: 'ویرایش وضعیت',
            render: (e) => {
                return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        style={{
                            background: color.primary, borderRadius: "5px", paddingTop: "4px",
                            width: "70px", display: 'flex', justifyContent: 'center', alignItems: 'center',
                            height: '25px'
                        }}>
                        <div style={{ cursor: "pointer" }}
                            onClick={() => { setEditStatus(true); setItem({ id: e._id }) }}
                        >  <EditOutlined />  </div>

                    </div>
                </div >
            }


        },

    ];

    const Status = (R) => {
        switch (R) {
            case "pending": return "درحال بررسی"
            case "completed": return "انجام شده"
            case "rejected": return "رد شده"
            case "cancelled": return "لغو شده"
        }
    }


    const updateSatus = () => {
        if (withdrawStatus.status != null && withdrawStatus.status != "") {
            if (data.status == "pending") {
                setLoading({ ...loading, 2: true })
                if (withdrawStatus.status == "rejected") {
                    if (withdrawStatus.rejectionReason != null && withdrawStatus.rejectionReason != "") {
                        var x = {
                            id: item.id,
                            status: withdrawStatus.status,
                            rejectionReason: withdrawStatus.rejectionReason
                        }
                    } else {
                        RedNotif("لطفا دلیل رد کردن درخواست را وارد نمایید")
                    }

                } else {
                    var x = {
                        id: item.id,
                        status: withdrawStatus.status
                    }
                }
                Axios.patch(`${url}withdraw/change-withdraw-status`, x)
                    .then(async (response) => {
                        if (response.status === 200 || response.status === 201) {
                            GreenNotif(response.message)
                            setLoading({ ...loading, 2: false })
                            setUpdater(updater + 1)
                        } else {
                            RedNotif(response.message);
                            setLoading({ ...loading, 2: false })

                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading({ ...loading, 2: false })

                    });
            } else {
                RedNotif("وضعیت درخواست مشخص شده و قابل تغییر نیست")
            }
        } else {
            RedNotif("لطفا وضعیت مورد نظر را انتخاب کنید")
        }
    }


    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }


    return (
        <>

            <Row >
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div style={{ background: color.onPrimary, width: '100%', height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ color: "white", fontSize: "18px" }}> اطلاعات برداشت</p>
                    </div>
                    <TABALE
                        data={data}
                        columns={columns}
                        page={pager}
                        loading={loading[1]}
                    />
                </Col>

            </Row>

            {
                editStatus == true
                    ?
                    <Row style={{ justifyContent: 'center', alignItems: 'center', marginTop: '64px' }}>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} style={{ padding: "0 20px" }} >

                            <SELECT
                                placeholder="وضعیت مورد نظر را انتخاب کنید"
                                click={(e) => setWithdrawStatus({ ...withdrawStatus, "status": e })}
                                items={statuses}
                                value={withdrawStatus.status} />
                        </Col>

                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} style={{ padding: "0 20px" }} >
                            <BUTTON event={(e) => {

                                updateSatus()
                                setWithdrawStatus({ ...withdrawStatus, "status": "", "rejectionReason": "" })
                            }} text="تغییر وضعیت " loading={loading} />

                        </Col>

                    </Row>

                    :
                    <p></p>
            }
            {
                withdrawStatus.status == "rejected"
                    ?
                    <Row style={{ justifyContent: 'center', alignItems: 'center', marginTop: '64px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>لطفا دلیل رد کردن درخواست را تایپ کنید:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} style={{ marginBottom: '28px' }}>
                            <INPUT
                                i={(e) => setWithdrawStatus({ ...withdrawStatus, "rejectionReason": e })}
                                value={withdrawStatus.rejectionReason != undefined && withdrawStatus.rejectionReason != null && withdrawStatus.rejectionReason != "0" ? withdrawStatus.rejectionReason : ""}
                            />
                        </Col>
                    </Row>
                    :
                    <p></p>
            }
        </>
    )
}
